import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=bd145dbc&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=bd145dbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd145dbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd145dbc')) {
      api.createRecord('bd145dbc', component.options)
    } else {
      api.reload('bd145dbc', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=bd145dbc&scoped=true&", function () {
      api.rerender('bd145dbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ASY7YVnoZQBa/JS/comp/DocBox.vue"
export default component.exports